import usegetdata from '../../Hooks/useGetData';
import {
  Get_All_Leads_Done_Deal_Only,
  Get_Error,
  Get_Total_Sales_And_Total_Commission_In_All_Months,
} from '../Types';

// get all Leads that thier stages = Done Deal
export const LeadsDoneDealOnly_Action = (quarystring) => async (dispatch) => {
  try {
    const res = await usegetdata(`/api/v1/users/Leads-DoneDealOnly?${quarystring}`);

    dispatch({
      type: Get_All_Leads_Done_Deal_Only,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};

// get Total Unit prices and total commissions in all months
export const Total_UnitPrices_And_Commissions_In_All_Months_Action = () => async (dispatch) => {
  try {
    const res = await usegetdata(`/api/v1/Commission/TotalCommissionsandSalesInAllMonths`);

    dispatch({
      type: Get_Total_Sales_And_Total_Commission_In_All_Months,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};
